import React, { useState } from 'react'
import EmptyTableContent from '../../../../error/EmptyTableContent'
import ServiceItem from './ServiceItem'
import ServicesTab from './ServicesTab'
function ServiceDateSection({ lastVisit, isUser = false }) {
  const [showDescription, setShowDescription] = useState(false)

  return (
    <>
      {lastVisit ? (
        <>
          <div className="flex flex-wrap gap-6 mb-8">
            <ServiceItem
              title={'کارکرد فعلی (دوره قبل)'}
              text={lastVisit?.['current_km']}
              icon={'icon-routing'}
            />
            <ServiceItem
              title={'مراجعه بعدی'}
              text={lastVisit?.['next_visit']}
              icon={'icon-data'}
            />
            {lastVisit?.['have_issue'] ? (
              <ServiceItem title={'خودرو دارای مشکل فنی است'} text={lastVisit?.['issue_desc']} />
            ) : null}
          </div>
          {!isUser && lastVisit?.description && (
            <div className={'flex flex-col mb-8'}>
              <div className="flex items-center mb-2">
                <h3 className={'text-lg font-normal dark:text-slate-200'}>توضیحات</h3>
                <i
                  className={`${
                    showDescription ? 'icon-eye' : 'icon-eye-blocked'
                  } text-3xl text-inactive-link mr-4 cursor-pointer dark:text-slate-200`}
                  onClick={() => setShowDescription(!showDescription)}
                />
              </div>
              {showDescription && (
                <p
                  className={
                    'bg-light-blue border border-inactive-link rounded-md py-2 px-4 text-lg dark:text-slate-200 dark:bg-slate-800'
                  }
                >
                  {lastVisit?.description}
                </p>
              )}
            </div>
          )}

          {lastVisit && (
            <ServicesTab current_km={lastVisit?.['current_km']} services={lastVisit?.services} />
          )}
        </>
      ) : (
        <EmptyTableContent text={'خدمتی ثبت نشده است.'} />
      )}
    </>
  )
}

export default React.memo(ServiceDateSection)
